module.exports = __webpack_public_path__ + "static/media/ship.2659a28c.svg";